import request from "@/utils/request";

// 查询学科列表
export const  checkJyeooToken =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/base/appGainToken",
        method:"get",
        params: query
    })
}

// 查询学科列表
export const  listSubject =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/base/gainSubject",
        method:"get",
        params: query
    })
}

// 查询全部学科列表
export const  listAllSubject =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/base/gainAllSubject",
        method:"get",
        params: query
    })
}

// 查询教材版本列表
export const  listEdition =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/base/gainEdition",
        method:"get",
        params: query
    })
}

// 查询教材版本年级列表
export const  listGrade =(data) =>{
    return request({
        url: "/authservice/jyeooAuth/base/gainGrade",
        method:"post",
        data: data
    })
}

// 查询教材列表
export const  listBook =(data) =>{
    return request({
        url: "/authservice/jyeooAuth/base/gainBookList",
        method:"post",
        data: data
    })
}

// 查询教材章节列表
export const  listCategory =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/base/gainBookCategory",
        method:"get",
        params: query
    })
}

// 查询教材章节列表
export const  listQuesType =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/base/gainQueType",
        method:"get",
        params: query
    })
}

// 查询试题来源列表
export const  listQuesSource =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/base/gainQueSource",
        method:"get",
        params: query
    })
}

// 查询试题能力列表
export const  listQuesAbility =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/base/gainAbility",
        method:"get",
        params: query
    })
}

// 查询试题列表
export const  listQuestion =(data) =>{
    return request({
        url: "/authservice/jyeooAuth/ques/gainQuesCondition",
        method:"post",
        data: data
    })
}

// 查询考点（知识点）列表
export const  listPoint =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/base/gainPoint",
        method:"get",
        params: query
    })
}


// 试题加入试题篮
export const  quesAddBasket =(data) =>{
    return request({
        url: "/authservice/jyeooAuth/basket/quesAddBasket",
        method:"post",
        data: data
    })
}

// 试题篮删除试题
export const  quesDelBasket =(data) =>{
    return request({
        url: "/authservice/jyeooAuth/basket/quesDelBasket",
        method:"post",
        data: data
    })
}

// 查询试题篮
export const  queryBasket =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/basket/gainBasket",
        method:"get",
        params: query
    })
}

// 清空试题篮
export const  clearBasket =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/basket/clearBasket",
        method:"get",
        params: query
    })
}

// 试题篮删除试题(按类型)
export const  delQuesByCate =(data) =>{
    return request({
        url: "/authservice/jyeooAuth/basket/delQuesByCate",
        method:"post",
        data: data
    })
}

// 生成组卷
export const  generatePaper =(data) =>{
    return request({
        url: "/authservice/jyeooAuth/paper/generatePaper",
        method:"post",
        data: data
    })
}

// 查询试题篮
export const  downPaper =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/paper/downPaper",
        method:"get",
        params: query
    })
}

// 查询组卷列表
export const  listPaper =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/paper/paperList",
        method:"get",
        params: query
    })
}

// 下载组卷
export const  downloadPaper =(data) =>{
    return request({
        url: "/authservice/jyeooAuth/paper/downPaper",
        method:"post",
        data: data
    })
}

// 查询用户组卷学段
export const  userPaperPeriod =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/user/userPaperPeriod",
        method:"get",
        params: query
    })
}

// 查询用户组卷学科
export const  userPaperSubject =(query) =>{
    return request({
        url: "/authservice/jyeooAuth/user/userPaperSubject",
        method:"get",
        params: query
    })
}